<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="PriceDiscPurchTable2" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :loading_width="100" :table_height_adjust="-8"
        :hb_table_class="'hb_table_price_disctable_purch_class1'" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed"
        @on_cell_button_click="on_cell_button_click" tableref="b141dc1b61f346eb806db9f0c8db9d7a">
        <template #query>
          {{ $t("common.company") }}：
          <el-select v-model="dataAreaId" filterable clearable :placeholder="$t('common.company')" style="width: 120px">
            <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
              :label="item.DataArea" :value="item.DataArea"></el-option>
          </el-select>
          {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="ItemRelation"></el-input>
          {{ $t("common.provider") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
            v-model="AccountRelation">
          </el-input>
          {{ $t("common.provider") + $t("common.name") }}：<el-input clearable size="small" style="width: 120px"
            v-model="SEI_Name"></el-input>
        </template>
        <template #toolbar>
          <el-tooltip content="数据同步" placement="top" effect="light">
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                class="iconfont icon-refresh"></i></el-button>
          </el-tooltip>
        </template>
        <!-- <template #toolbar="">
          <el-button type="info" plain @click="createForm('new')" style="width: 55px" class="ml-2 iconfont icon-add-new" size="mini"></el-button>
        </template> -->
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import * as PriceDiscPurchTableController from "../../controllers/base/PriceDiscPurchTableController"
// import { delete } from 'vue/types/umd';

export default {
  name: "PriceDiscTable",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_pricedic_purch",
      },
      fields: PriceDiscPurchTableController.fields.default,
      dataForm: _.cloneDeep(PriceDiscPurchTableController.dataForm),
      rules: PriceDiscPurchTableController.rules,
      AccountRelation: "",
      SEI_Name: "",
      ItemRelation: "",
      dataAreaId: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let _params = {
        company: "070",
        tableName: "secp_PriceDiscTable",
        accountNum: "", //不传则查询所有
      }
      await PriceDiscPurchTableController.methods.pickAndInvoke(_params)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.PriceDiscPurchTable2.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }
        let _result = await PriceDiscPurchTableController.methods.getData(_params)

        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.PriceDiscPurchTable2.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }
      this.isBusy = false
    },
    //#region 查询
    async on_query(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      this.isBusy = true
      let _params = {}
      // if (this.AccountRelation != "") {
      //   _params.AccountRelation = { "like": "%" + this.AccountRelation + "%" }
      // }
      // if (this.ItemRelation != "") {
      //   _params.ItemRelation = { "like": "%" + this.ItemRelation + "%" }
      // }
      // if (this.dataAreaId != "") {
      //   _params.dataAreaId = { "=": this.dataAreaId }
      // }
      if (
        !_.isNull(date_range) &&
        this.AccountRelation == "" &&
        this.ItemRelation == "" &&
        this.dataAreaId == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        //_params["modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      _params.FromDate = _fromDate
      _params.ToDate = _toDate
      _params.s_ItemRelation = this.ItemRelation
      _params.s_AccountRelation = this.AccountRelation
      _params.SEI_Name = this.SEI_Name
      _params.dataAreaId = this.dataAreaId
      if (this.SEI_Name != "") {
        delete _params.dataAreaId
      }
      let _result = await PriceDiscPurchTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) { },
    //#endregion

    ///cell点击
    on_cell_button_click(data) {

    },

    current_changed(old, current) {

    },
  },
}
</script>

<style>
.hb_table_price_disctable_purch_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}
</style>
